<div class="flex">
  @if (editMode) {
    <mat-form-field class="flex-1" subscriptSizing="dynamic">
      <mat-label>{{ label }}</mat-label>
      <pr-editor-input
        cdkFocusInitial
        [required]="required"
        [formControl]="formControl"
      />
    </mat-form-field>
  } @else {
    <pr-template-preview
      class="flex-1"
      [template]="formControl.value"
      [context]="context$ | async"
      [type]="templateType$ | async"
    />
  }
</div>
<div class="flex gap-4 px-2 pt-2">
  <ng-content />
  <div class="flex-1">
    <a
      mat-button
      color="primary"
      [matTooltip]="templateVariablesTooltip"
      (click)="openContextPreviewDialog()"
    >
      Personalise your content with template variables
    </a>
  </div>

  @if (editMode) {
    <a mat-button color="primary" (click)="editMode = false">Preview</a>
  } @else {
    <a mat-button color="primary" (click)="editMode = true">Edit</a>
  }
</div>
